import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import NavLink from 'components/NavLink';
import uuid from 'uuid/v4';
import SubMenu from '../MenuDesktop/SubMenu';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const MenuItem = ({ item, child, mobile }) => {
  const router = useRouter();

  let itemClassName = '';
  const currentSlug = router.asPath.replace(/\/$/, '').split('/').pop();
  if (item.slug === currentSlug) {
    itemClassName = `menu-item menu-item-type-post_type menu-item-object-page current-menu-item current_page_item menu-item-${item.ID}`;
  }

  return (
    <li key={uuid()} className={itemClassName}>
      {item.type === 'taxonomy' ? (
        <NavLink
          basePath={publicRuntimeConfig.PUBLIC_URL}
          as={`${item?.permalink}`}
          to={`/category?permalink=${item.permalink}`}
          routerStrategy={'next'}
        >
          {item.title || item.name}
        </NavLink>
      ) : (
        <NavLink
          to={`${item.link}`}
          routerStrategy={'none'}
        >
          {item.title || item.name}
        </NavLink>
      )}

      {child && !mobile && <SubMenu items={child} />}
    </li>
  );
};

MenuItem.propTypes = {
  item: PropTypes.object,
  child: PropTypes.array,
  mobile: PropTypes.bool,
};

export default MenuItem;
